import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_BEGIN,
  REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_SUCCESS,
  REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_FAILURE,
  REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_DISMISS_ERROR,
} from './constants';

export function fetchScInActionCustomerData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getScInActionCustomerReport`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              customerSummary: res.data && res.data.summary
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchScInActionCustomerDataError() {
  return {
    type: REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_DISMISS_ERROR,
  };
}

export function useFetchScInActionCustomerData() {
  const dispatch = useDispatch();

  const { reportsCustomerData, reportsCustomerTotals, customerSummary,fetchScInActionCustomerDataPending, fetchScInActionCustomerDataError } = useSelector(
    state => ({
      reportsCustomerData: state.reports.reportsCustomerData,
      reportsCustomerTotals: state.reports.reportsCustomerTotals,
      customerSummary: state.reports.customerSummary,
      fetchScInActionCustomerDataPending: state.reports.fetchScInActionCustomerDataPending,
      fetchScInActionCustomerDataError: state.reports.fetchScInActionCustomerDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchScInActionCustomerData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchScInActionCustomerDataError());
  }, [dispatch]);

  return {
    reportsCustomerData,
    reportsCustomerTotals,
    customerSummary,
    fetchScInActionCustomerData: boundAction,
    fetchScInActionCustomerDataPending,
    fetchScInActionCustomerDataError,
    dismissFetchScInActionCustomerDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchScInActionCustomerDataPending: true,
        fetchScInActionCustomerDataError: null,
      };

    case REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsCustomerData: action.data.data,
        reportsCustomerTotals: action.data.totals,
        customerSummary: action.data.customerSummary,
        fetchScInActionCustomerDataPending: false,
        fetchScInActionCustomerDataError: null,
      };

    case REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchScInActionCustomerDataPending: false,
        fetchScInActionCustomerDataError: action.data.error,
      };

    case REPORTS_FETCH_SC_IN_ACTION_CUSTOMER_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchScInActionCustomerDataError: null,
      };

    default:
      return state;
  }
}
